import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { disciplines, projects, projectsByDiscipline } from "../data/projects";
import { Reveal, MaskLines, SectionMark } from "./ui/Primitives";
import ProjectCard from "./ui/ProjectCard";

const HomePortfolioPreview: React.FC = () => {
  const lead = projects[0];

  // One representative piece per discipline, so the breadth of the practice is
  // legible from the home page without scrolling the whole portfolio.
  const rest = disciplines
    .slice(1)
    .map((d) => ({ discipline: d, project: projectsByDiscipline(d.id)[0] }))
    .filter((entry) => Boolean(entry.project));

  return (
    <section className="relative bg-ink-2 py-24 lg:py-36">
      <div className="shell">
        <Reveal>
          <SectionMark label="הפרויקטים שלנו" index="02" />
        </Reveal>

        <MaskLines
          as="h2"
          className="t-h1 mb-6 text-fg"
          lines={["תיק עבודות", "שמדבר בעד עצמו"]}
        />

        <Reveal delay={100}>
          <p className="t-lead mb-14 max-w-[48ch]">
            אתרים, אפליקציות מובייל, דשבורדים וכלי AI. ארבעה תחומים נפרדים, אותה
            רמת גימור.
          </p>
        </Reveal>

        <Reveal>
          <ProjectCard project={lead} ratio="21 / 9" size="lg" />
        </Reveal>

        <div className="mt-16 grid gap-x-8 gap-y-14 md:grid-cols-3">
          {rest.map(({ discipline, project }, i) => (
            <Reveal key={discipline.id} delay={i * 90}>
              <p className="t-meta mb-4 border-t border-[var(--line)] pt-3">
                {discipline.label}
              </p>
              <ProjectCard project={project} ratio="4 / 3" />
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-20">
            <Link to="/portfolio" className="btn btn-primary">
              <span>לכל תיק העבודות</span>
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HomePortfolioPreview;
